import React, { HTMLProps, ReactNode } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { Placement } from "react-bootstrap/esm/types";
import classNames from "classnames";
import { Popover } from "react-bootstrap";
import Button, { ButtonProps } from "../theme/button/Button";
import Text from "../theme/text/Text";
import Icon from "../theme/icon/Icon";
import Styles from "./AIButton.module.scss";

interface AIButtonProps extends ButtonProps {
    previewText?: string;
    popoverTitle?: string;
    popoverBody?: ReactNode;
    name?: string;
    placement?: Placement;

}

const ArtificialIntelligenceButton = React.forwardRef((
    args: AIButtonProps,
    ref: React.ForwardedRef<HTMLButtonElement>,
): ReactNode => {
    const {
        name,
        previewText,
        onClick,
        className,
        popoverBody,
        popoverTitle,
        ...rest
    } = args;

    const popover = (
        <Popover className={Styles.popover}>
            {popoverTitle && (
                <Popover.Header>
                    {popoverTitle}
                </Popover.Header>
            )}
            <Popover.Body>
                {popoverBody || previewText}
            </Popover.Body>
        </Popover>
    );

    return (

        <OverlayTrigger
            trigger="hover"
            overlay={popover}
            rootClose
        >
            <Button
                onClick={onClick}
                size="xsmall"
                variant="ghost-blue"
                className={classNames(className, Styles["ai-button"])}
                prefixIcon={<Icon.ArtificialIntelligence />}
                ref={ref}
                {...rest}
            >
                {name}
                {name && previewText && ": "}
                {previewText && (
                    <Text as="span" textVariant="body-2-regular">
                        {previewText}
                    </Text>
                )}

            </Button>

        </OverlayTrigger>

    );
});

ArtificialIntelligenceButton.defaultProps = {
    previewText: undefined,
    name: undefined,
    placement: undefined,
    popoverBody: undefined,
};

export default ArtificialIntelligenceButton;
